"use client";

import ImageCustom from "@/components/Image";
import { Utils } from '@/libs/Utils';
import { usePathname, useRouter } from "next/navigation";
import React, { useState } from "react";
import { CiCircleRemove } from "react-icons/ci";

interface HeaderSearchProps {
  locale: string
  referrer?: string
  // blocks: Array<BlockType>
}

const HeaderSearch: React.FC<HeaderSearchProps> = ({ 
  locale,
  referrer 
}) => {
  
    const t = new Utils(locale).Translation
    const [showSearch, setShowSearch] = useState(false);
    const [searchText, setSearchText] = useState("");
    const pathname = usePathname();
    const router = useRouter();
    const handleSearch = async(event: any) => {
        event.preventDefault();
        
        // const results = await Search(locale);

        if (!searchText?.trim()) {
          return;
        }
        const localeString = Array.isArray(locale) ? locale[0] : locale;
        window.location.href = `/${locale}/search?q=${searchText}`
    }

  return (
    <div className="menu-dropdown my-auto">
      <form
        className={`${showSearch &&
          " overflow-hidden w-auto transition-all h-100"
          } d-lg-block d-none`}
        onSubmit={handleSearch}
      >
        <div className="d-flex align-items-center ">
          {showSearch && (
            <input
              id='q'
              value={searchText}
              name="query"
              onChange={(e) => setSearchText(e.target.value)}
              className="bg-grey-100 py-2 outline-none ps-2 d-lg-flex text-base fw-normal border end-50"
              placeholder={`${t("header.search")}...`}
            />
          )}
          <div
            className="px-2 cursor-pointer"
            onClick={() => setShowSearch((prev) => !prev)}
          >
            {!showSearch ? (
              <div className="w-[24px] position-relative aspect-ratio-square">
                <ImageCustom
                  alt="searchsvg"
                  fill
                  src="https://static.vncdn.vn/www.vncdn.vn/pub/websites/uploads/1/search.svg"
                  className="position-relative"
                />
              </div>
            ) : ( <CiCircleRemove className="text-black" size={25} />
            )}
          </div>
        </div>
      </form>

      <form
        onSubmit={handleSearch}
        className="bg-grey-100 d-lg-none d-block overflow-hidden rounded-2 transition-all h-100"
      >
        <div className="d-flex flex-row justify-content-between">
          <input
            id='q'
            value={searchText}
            name="query"
            onChange={(e) => setSearchText(e.target.value)}
            className="bg-grey-100 py-2 outline-none ps-2 d-lg-flex text-base fw-normal border w-100"
            placeholder={`${t("header.search")}...`}
          />

          <div className="px-1 py-2 cursor-pointer">
            <div className="w-[24px] position-relative aspect-ratio-square">
              <ImageCustom alt="search_24px.svg" fill src="https://static.vncdn.vn/www.vncdn.vn/pub/websites/uploads/1/search.svg" className="position-relative"/>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default HeaderSearch;
